











export default {
  name: 'SfBadge',
};
